import { defineAsyncComponent } from '../../../lib/utils/vue3compat/vue.js?vue3';
import { DUO_CHAT_AGENT_PLANNER, DUO_CHAT_QUICK_ACTION_SUMMARIZE } from '~/ai/constants';
import { s__ } from '~/locale';
import WorkItemActivitySortFilter from './work_item_activity_sort_filter.vue?vue3';
import { ASC } from '~/notes/constants';
import { WORK_ITEM_NOTES_FILTER_ALL_NOTES, WORK_ITEM_ACTIVITY_FILTER_OPTIONS, WORK_ITEM_NOTES_FILTER_KEY, WORK_ITEM_ACTIVITY_SORT_OPTIONS, WORK_ITEM_NOTES_SORT_ORDER_KEY } from '~/work_items/constants';
export default {
    name: 'WorkItemNotesActivityHeader',
    components: {
        DuoChatQuickAction: defineAsyncComponent(()=>import('../../../../../../ee/app/assets/javascripts/ai/shared/widgets/duo_chat_quick_action.vue?vue3')),
        WorkItemActivitySortFilter
    },
    props: {
        canSummarizeComments: {
            type: Boolean,
            required: false,
            default: false
        },
        disableActivityFilterSort: {
            type: Boolean,
            required: true
        },
        sortOrder: {
            type: String,
            default: ASC,
            required: false
        },
        workItemId: {
            type: String,
            required: true
        },
        workItemType: {
            type: String,
            required: true
        },
        discussionFilter: {
            type: String,
            default: WORK_ITEM_NOTES_FILTER_ALL_NOTES,
            required: false
        },
        useH2: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: [
        'change-filter',
        'change-sort'
    ],
    computed: {
        summarizeTracking () {
            return {
                label: 'work_item_view_summary',
                property: this.workItemType
            };
        }
    },
    buttonOptions: {
        size: 'small'
    },
    classicQuickAction: DUO_CHAT_QUICK_ACTION_SUMMARIZE,
    summarizeCommand: {
        agent: {
            name: DUO_CHAT_AGENT_PLANNER
        },
        agenticPrompt: s__('AI|Summarize the comments on this issue.')
    },
    WORK_ITEM_ACTIVITY_FILTER_OPTIONS,
    WORK_ITEM_NOTES_FILTER_KEY,
    WORK_ITEM_NOTES_FILTER_ALL_NOTES,
    WORK_ITEM_ACTIVITY_SORT_OPTIONS,
    WORK_ITEM_NOTES_SORT_ORDER_KEY,
    ASC
};
